import script from "./Carousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./Carousel.vue?vue&type=script&lang=ts&setup=true"

import "./Carousel.vue?vue&type=style&index=0&id=6fa63937&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa63937"]])

export default __exports__